import { useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "sonner";
import { api, formatApiError, scrollToId } from "../lib/api";

export const Footer = () => {
  const [email, setEmail] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await api.post("/newsletter", { email });
      toast.success("You're on the list — seasonal dates coming soon.");
      setEmail("");
    } catch (err) {
      toast.error(formatApiError(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <footer data-testid="site-footer" className="relative bg-[#0A0908] border-t border-[rgba(212,175,55,0.15)] pt-20 pb-10">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="grid lg:grid-cols-2 gap-12 items-end pb-14">
          <div>
            <p className="overline-label">The Seasonal Letter</p>
            <h3 className="font-serif-display text-3xl lg:text-4xl font-light text-[#F4F1EA] mt-4">
              Release dates, before anyone else.
            </h3>
          </div>
          <form data-testid="newsletter-form" onSubmit={submit} className="flex gap-0">
            <input
              data-testid="newsletter-input-email"
              required
              type="email"
              placeholder="Email address"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="flex-1 bg-[#141210] border border-[rgba(212,175,55,0.2)] focus:border-[#D4AF37] outline-none px-4 py-4 text-sm text-[#F4F1EA] placeholder:text-[#6E685E] transition-colors"
            />
            <button
              data-testid="newsletter-submit-btn"
              disabled={busy}
              className="font-mono text-xs uppercase tracking-[0.2em] bg-[#D4AF37] text-[#0A0908] px-6 hover:bg-[#F4F1EA] transition-colors disabled:opacity-50"
            >
              {busy ? "…" : "Subscribe"}
            </button>
          </form>
        </div>

        <div className="gold-hairline" />

        <div className="grid sm:grid-cols-3 gap-10 py-14">
          <div>
            <p className="font-serif-display text-xl text-[#F4F1EA]">Delta Breeze</p>
            <p className="font-mono text-[10px] uppercase tracking-[0.35em] text-[#6E685E] mt-1">Winery</p>
            <p className="text-sm text-[#6E685E] mt-4 leading-relaxed max-w-xs">
              Small-lot wines from the California Delta. Picked by hand, bottled when honest.
            </p>
          </div>
          <div className="flex flex-col gap-3">
            <p className="font-mono text-[10px] uppercase tracking-[0.3em] text-[#6E685E] mb-1">Explore</p>
            {["story", "wines", "club", "events", "visit"].map((id) => (
              <button
                key={id}
                data-testid={`footer-link-${id}`}
                onClick={() => scrollToId(id)}
                className="self-start text-sm text-[#A39E93] hover:text-[#D4AF37] transition-colors capitalize"
              >
                {id}
              </button>
            ))}
          </div>
          <div className="flex flex-col gap-3">
            <p className="font-mono text-[10px] uppercase tracking-[0.3em] text-[#6E685E] mb-1">Contact</p>
            <a
              data-testid="footer-contact-email"
              href="mailto:admin@deltabreezewinery.com"
              className="text-sm text-[#A39E93] hover:text-[#D4AF37] transition-colors"
            >
              admin@deltabreezewinery.com
            </a>
            <p className="text-sm text-[#A39E93]">California Delta</p>
            <Link
              to="/admin"
              data-testid="admin-nav-button"
              className="text-sm text-[#6E685E] hover:text-[#D4AF37] transition-colors mt-2"
            >
              Cellar Door (Admin)
            </Link>
          </div>
        </div>

        <div className="gold-hairline" />
        <p className="font-mono text-[10px] uppercase tracking-[0.25em] text-[#6E685E] text-center pt-8">
          © {new Date().getFullYear()} Delta Breeze Winery · Please enjoy responsibly
        </p>
      </div>
    </footer>
  );
};
